'use client'
// The walls that stand on their own for him to paint (Sam, 2 Nov: "lets add a couple more walls he can spray on in the
// world"). The others are faces of buildings; this one is a wall of its own, concrete with a coping, behind the rave's
// speakers and facing the square, laid out in Kiwi_world.blend's 'Tag walls' collection AT WORLD COORDINATES, so it
// renders at identity like the carriage. What he paints on it hangs from tag_09 in tag_planes.glb (SprayWalls.jsx), and
// what he walks round is obs_tagwall_rave in obstacles.glb. Exported by scripts/blender/wants-sync.py (EXPORT
// 'tag_walls'), then optimize-glb.
import { useSceneNodeMaterials } from '../hooks/useSceneNodeMaterials'
import { useModel } from '../hooks/useModel'

const MODEL = '/models/tag_walls.glb'

export function TagWalls() {
  const { scene } = useModel(MODEL)
  useSceneNodeMaterials(scene, { roughness: 0.95 })
  // Baked transform: render at identity.
  return <primitive object={scene} />
}

export default TagWalls
